import * as React from 'react';
import { Checkbox, FormControlLabel, FormControl, FormHelperText } from '@material-ui/core';
import { Controller, useFormContext, useController, get } from 'react-hook-form';

export const CheckBoxCustom = ({ label, onClick, ...props }) => {
    const { control, formState } = useFormContext();
    const { meta } = useController(props);
    const error = get(formState.errors, props.name);
    const errorText = meta.invalid ? error.message : '';
    return (
        <FormControl error={!!errorText}>
            <FormControlLabel
                control={
                    <Controller
                        {...props}
                        control={control}
                        render={(props) => (
                            <Checkbox
                                onChange={(e) => props.onChange(e.target.checked)}
                                checked={props.value}
                                color="primary"
                                onClick={onClick}
                            />
                        )}
                        defaultValue={props.defaultValue}
                    />
                }
                label={label}
            />
            <FormHelperText>{errorText}</FormHelperText>
        </FormControl>
    );
};
